/** Built-in management role IDs stored on graph MANAGER edges / snapshot enrichment. */
export const MANAGEMENT_ROLE_ID = {
	PRIMARY_MANAGER: 'management-primary-manager',
	COLLABORATIVE_MANAGER: 'management-collaborative-manager',
	COACH: 'management-coach',
	BUDDY: 'management-buddy',
} as const;

export type ManagementRoleType = keyof typeof MANAGEMENT_ROLE_ID;

export const MANAGEMENT_ROLE_TYPES = Object.keys(MANAGEMENT_ROLE_ID) as ManagementRoleType[];
